import React, { Component } from "react";
import { Subject } from "rxjs";
import { IImage } from "../../../models/Image";
import MediaOverlay, { GalleryProps } from "./MediaOverlay";
// import { ShareProps } from "../Share.tsx__";

// TODO: later will support audio as well

type MediaShowEvtType = {
	media: IImage;
	shareable: boolean;
} & GalleryProps;

type AppMediaOverlayState = {
	openMedia: boolean;
	share: boolean;
	media: IImage;
} & GalleryProps;

// Single component loaded in app listening for event to display MediaOverlay
export class AppMediaOverlay extends Component<any, AppMediaOverlayState> {
	private _sub: any;

	state = {
		openMedia: false,
		share: false,
		media: null,
		galleryImages: null,
		selectedMediaIndex: undefined,
	};

	componentDidMount() {
		this._sub = OverlayService.events.subscribe((evt: MediaShowEvtType) => {
			this.setState({
				media: evt.media,
				openMedia: true,
				share: evt.shareable,
				selectedMediaIndex: evt.selectedMediaIndex,
				galleryImages: evt.galleryImages,
			});
		});
	}

	componentWillUnmount() {
		if (this._sub && this._sub.unsubcribe) {
			this._sub.unsubcribe();
		}
	}

	render() {
		return (
			<MediaOverlay
				displayMedia={this.state.openMedia}
				selectedMedia={this.state.media}
				displayShare={this.state.share}
				onClose={() => {
					this.setState({ openMedia: false });
				}}
				selectedMediaIndex={this.state.selectedMediaIndex}
				galleryImages={this.state.galleryImages}
			/>
		);
	}
}

class MediaOverlayService {
	public events = new Subject<MediaShowEvtType>();

	public show(media: IImage, shareable: boolean, galleryImages?: IImage[], selectedMediaIndex?: number): void {
		console.log("MediaOverlayService.show()", media, shareable, galleryImages, selectedMediaIndex);
		this.events.next({ media, shareable, galleryImages, selectedMediaIndex });
	}
}

const Singleton = (function () {
	let _overlayService: MediaOverlayService;

	return {
		getInstance: (): MediaOverlayService => {
			if (!_overlayService) {
				_overlayService = new MediaOverlayService();
			}
			return _overlayService;
		},
	};
})();

const OverlayService = Singleton.getInstance();
export default OverlayService;
